import { guestlistClient } from "@nexxt/api-client/guestlist";
import { createQueryClient, liveCapture } from "@nexxt/app-kit";
import type { QueryClient } from "@tanstack/react-query";
import { loginHref } from "./features/auth/sign-in";

let signingIn = false;

/** No session, or it expired or was revoked: the gateway's Logto login (ADR-294), then back to the same page. */
function signIn(): void {
  if (signingIn) return;
  signingIn = true;
  // a full load: nothing of the previous user stays in memory
  location.assign(loginHref(`${location.pathname}${location.search}`));
}

export const { api, auth } = guestlistClient({ ...liveCapture, onUnauthenticated: signIn });

export const queryClient: QueryClient = createQueryClient();
